import { Component, inject } from '@angular/core';
import { AuthService } from '@app/components/login.component';
import { PrimeNGButtonOpenItemViewActionComponent } from '@ntap/primeng';
import { map, mergeMap } from 'rxjs';

@Component({
  selector: 'app-edit-agent-item-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class EditAgentItemActionComponent extends PrimeNGButtonOpenItemViewActionComponent {
  private authService = inject(AuthService);

  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.itemProvider.item$.pipe(
      mergeMap((item) => {
        const pravoUredjivanjaPodatakaOsobeId =
          ((item as any)[
            'en~agent~pravo_uredjivanja_podataka_osobe'
          ] as number[]) || [];
        const uIzradi =
          ((item as any)['en~agent~status_obrade_id'] as number) == 1;

        return this.authService.validUser$.pipe(
          map((user) => {
            const userHasRoles = AuthService.userHasAnyRole(user, [
              'Glavni administrator',
              'Voditelj normativne baze osoba'
            ]);

            if (
              userHasRoles ||
              (uIzradi &&
                pravoUredjivanjaPodatakaOsobeId.indexOf(user.userId?.value) >
                  -1)
            ) {
              return false;
            }

            return true;
          })
        );
      })
    );
  }
}
